import { ref, computed } from 'vue'

import { defineStore, acceptHMRUpdate } from 'pinia'

import { util } from '@/Helpers'

import moment from 'moment'

export const useStaffStore = defineStore('staff', () => {

    const allStaffs = ref([])
    const activeStaffs = ref([])
    const staffs = ref({})

    const loading = ref(false)

    const lastUpdated = ref(null)

    function defaultStaff() {
        return {
            id: null,
            coffee_auth_user_id: null,
            email: null,
            first_name: '',
            last_name: '',
            phone_numbers: [],
        }
    }

    //
    // Hydration
    //

    async function hydrateFromJobs(jobsData) {

        staffs.value = Object.assign(staffs.value, util.convertArrayToObject(jobsData.map(job => job.client.assigned_sales_manager), 'id'))

        staffs.value = Object.assign(staffs.value, util.convertArrayToObject(jobsData.map(job => job.caregiver.assigned_recruiter), 'id'))

        // Reshape phone numbers
        Object.values(staffs.value).forEach(staff => {
            if (Array.isArray(staff.phone_numbers)) {
                staff.phone_numbers = staff.phone_numbers ? util.convertArrayToObject(staff.phone_numbers, 'type') : { work: { number: '5555555555' } }
            }
        })

        lastUpdated.value = moment.utc()

    }

    async function hydrateAllStaffs(data) {
        allStaffs.value = data
        activeStaffs.value = data.filter(staff => staff.is_active)
    }

    async function getAllStaffs() {
        return await new Promise((resolve, reject) => {
            loading.value = true
            axios.get(
                `/api/v1/staffs`
            ).then(response => {
                resolve(response)
            }).catch((err) => {
                authStore.handleError(err)
                reject({ "error": err })
            }).finally(() => {
                loading.value = false
            })
        });
    }

    function getStaffById(id) {
        const staff = allStaffs.value.find(staff => staff.id === id);

        if (!staff) {
            console.warn(`Staff with ID ${id} not found.`);
        }

        return staff;
    }

    const excludedStaffIds = ref(import.meta.env.VITE_DATA_COMPLETION_EXCLUDE_STAFF_IDS
        ? import.meta.env.VITE_DATA_COMPLETION_EXCLUDE_STAFF_IDS.split(',').map(id => parseInt(id))
        : []);

    const activeStaffsWithClients = computed(() => {
        // TODO: Formalize this exclusion list somewhere else
        return allStaffs.value.filter(staff => staff.is_active && !excludedStaffIds.value.includes(staff.id));
    })

    return {
        loading,
        defaultStaff,
        hydrateFromJobs, hydrateAllStaffs, getAllStaffs, getStaffById,
        staffs, allStaffs, activeStaffs, activeStaffsWithClients, lastUpdated
    }

})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useStaffStore, import.meta.hot))
}
